<template>
  <div>
    <task-add></task-add>
  </div>
</template>

<script>
import TaskAdd from './TaskAdd.vue';

export default {
  components: {
    TaskAdd,
  },

  data() {
    return {};
  },
};
</script>
